import React, {useEffect, useState} from "react";
import {Col, Row, Button, Form, Input, message} from "antd";
import {DownloadOutlined, SaveOutlined} from '@ant-design/icons';
import {useAuth} from '../../hooks';
import '../styles/Account.less';
import {
  doc,
  updateDoc,
  query,
  collection,
  where,
  getDocs,
} from "firebase/firestore";
import {firestore} from '../../services/firebase';
import {useHistory} from "react-router-dom";

const Account = () => {

  const history = useHistory();
  const [form_user] = Form.useForm();
  const [reconocimiento, setReconocimiento] = useState(false);
  const [loading, setLoading] = useState(true);
  const {userData} = useAuth();
  const [lsUser, setLsUser] = useState(null);
  const [lsUserLoading, setLsUserLoading] = useState(true)
  const {idDoc} = userData[0];
  const activo = true;

  const onFinish = async (values) => {
    const {nombre, apellidos} = values;
    try {
      const resp = await updateDoc(doc(firestore, "usuarios", idDoc), {
        nombre,
        apellidos,
      });
      localStorage.clear();
      setLsUser({
        ...lsUser,
        nombre,
        apellidos
      });
      localStorage.setItem('usuario', JSON.stringify({...lsUser, nombre, apellidos}))

      !resp && message.success('Se guardó correctamente.');
    } catch (error) {
      console.log(error)
      message.warning('Error al guardar');
    }
  }

  const onFinishFailed = (onFinishFailed) => {
    console.log("Failed: ", onFinishFailed);
  };
  useEffect(() => {
    let mounted = true;
    if (mounted) {

      setTimeout(async () => {
        const q = query(collection(firestore, "contador"), where("idUsuario", "==", idDoc));
        const querySnapShot = await getDocs(q);
        let count = 0;
        querySnapShot.forEach((doc) => {
          count++;
        });
        if (count > 0) {
          setReconocimiento(true);
        }
        setLoading(false)

      }, 100);

      if (!lsUserLoading) {
        form_user.setFieldsValue({
          ...JSON.parse(localStorage.getItem('usuario'))
        });
      }
    }
    return () => {
      mounted = false
    };

  }, [idDoc, lsUserLoading, form_user]);

  useEffect(() => {
    if (setLsUserLoading) {
      setLsUser(JSON.parse(localStorage.getItem('usuario')));
      setLsUserLoading(false)
    }
  }, []);

  return (
    <Form
      name="form_user"
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      form={form_user}
    >
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Form.Item
            label="Nombre"
            name="nombre"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              autoComplete="off"
              size="large"/>
          </Form.Item>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Form.Item
            label="Apellidos"
            name="apellidos"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              autoComplete="off"
              size="large"/>
          </Form.Item>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Form.Item
            label="Correo electrónico"
            name="correo"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              autoComplete="off"
              disabled
              size="large"/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Form.Item
            label="Teléfono"
            name="telefono"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              disabled
              autoComplete="off"
              size="large"/>
          </Form.Item>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Form.Item
            label="País"
            name="pais"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              disabled
              autoComplete="off"
              size="large"/>
          </Form.Item>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Form.Item
            label="Ciudad"
            name="ciudad"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              autoComplete="off"
              disabled
              size="large"/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 12, offset: 0}}
          lg={{span: 12, offset: 0}}
          xxl={{span: 12, offset: 0}}
        >
          <Form.Item
            label="Empresa"
            name="empresa"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              disabled
              autoComplete="off"
              size="large"/>
          </Form.Item>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 12, offset: 0}}
          lg={{span: 12, offset: 0}}
          xxl={{span: 12, offset: 0}}
        >
          <Form.Item
            label="Ocupación"
            name="ocupacion"
            rules={[{required: true, message: "Requerido"}]}>
            <Input
              disabled
              autoComplete="off"
              size="large"/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 7, offset: 10}}
          lg={{span: 6, offset: 12}}
          xxl={{span: 5, offset: 14}}
        >

          <Button
            loading={loading}
            type="dashed"
            size="large"
            block
            onClick={() => history.push(`/pdf`)}
            icon={<DownloadOutlined/>}
          >
            Descargar reconocimiento
          </Button>

        </Col>

        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 7, offset: 0}}
          lg={{span: 6, offset: 0}}
          xxl={{span: 5, offset: 0}}
        >
          <Button
            type="primary"
            htmlType="submit"
            icon={<SaveOutlined/>}
            block
            size="large">
            Guardar
          </Button>
        </Col>
      </Row>

    </Form>
  )
};

export default Account;
